import { Typography, Box } from "@mui/material";

const AlertPage = ({ title, icon, message }) => {
  return (
    <div className={"flex flex-col justify-center items-center flex-grow"}>
      <Typography
        className={" text-gray-600"}
        sx={{
          fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          mt: ["2rem", "2rem", "2rem", "2rem", "4rem", "4rem"],
          "& img": {
            height: ["80px", "80px", "80px", "80px", "135px", "135px"],
          },
        }}
      >
        <img src={icon} alt={`${title}-icon`} />
      </Box>
      <Box
        className={"flex max-w-xs text-center text-gray-600"}
        sx={{ mt: ["2rem", "2rem", "2rem", "2rem", "4rem", "4rem"] }}
      >
        <Typography
          sx={{
            fontSize: [
              "0.75rem",
              "0.75rem",
              "0.75rem",
              "0.75rem",
              "1rem",
              "1rem",
            ],
          }}
        >
          {message}
        </Typography>
      </Box>
    </div>
  );
};

export default AlertPage;
